import Ibrahim from '../../../assets/Companies/Ibrahim.png';
import Nishat from '../../../assets/Companies/Nishat.svg';
import Sazgar from '../../../assets/Companies/Sazgar.png';
import Etihad from '../../../assets/Companies/Etihad.jpeg';
import AliMurtaza from '../../../assets/Companies/Ali Murtaza.png';
import KEMC from '../../../assets/Companies/KEMC.jpeg';
import Alaleem from '../../../assets/Companies/Alaleem.jpeg';
import Nespak from '../../../assets/Companies/Nespak.png';
import UGOC from '../../../assets/Companies/UGOC.png';
import UniFSD from '../../../assets/Companies/Uni FSD.png';
import AFH from '../../../assets/Companies/AFH.png';
import Mecatech from '../../../assets/Companies/Mecatech.png';
import CrescentBahuman from '../../../assets/Companies/Crescent bahuman.png';
import Diamond from '../../../assets/Companies/Diamond.png';
import Olympia from '../../../assets/Companies/Olympia.png';
import Sapphire from '../../../assets/Companies/Sapphire.png';
import Atlas from '../../../assets/Companies/Atlas.png';
import JKSugars from '../../../assets/Companies/Jk.png';
import JKDairyFarm from '../../../assets/Companies/JK DairyFarm.jpg';
import Ihsan from '../../../assets/Companies/Ihsan.jpg';
import Haier from '../../../assets/Companies/Haier.png';
import Hamdard from '../../../assets/Companies/Hamdard.png';
import Marhaba from '../../../assets/Companies/Marhaba.jpeg';
import Sabroso from '../../../assets/Companies/Sabroso.png';
import Maheen from '../../../assets/Companies/Maheen.png';
import Malmo from '../../../assets/Companies/Malmo.png';
import SapphireDairies from '../../../assets/Companies/Sapphire dairies.jpg';
import KhalasSaleKurma from '../../../assets/Companies/Khalas.png';
import GlamourGarments from '../../../assets/Companies/Glamour Garments.jpeg';
import Divine from '../../../assets/Companies/Divine.png';

// Define your client data with the correct image paths
const ClientsData = [
  { name: "Ibrahim Group", logo: Ibrahim },
  { name: "Nishat", logo: Nishat },
  { name: "Sazgar", logo: Sazgar },
  { name: "Etihad Alloys", logo: Etihad },
  { name: "Ali Murtaza", logo: AliMurtaza },
  { name: "King Edward Medical College", logo: KEMC },
  { name: "Crescent Bahuman", logo: CrescentBahuman },
  { name: "Nespak", logo: Nespak },
  { name: "Umer Group of Companies", logo: UGOC },
  { name: "The University of Faisalabad", logo: UniFSD },
  { name: "Ali Fatima Hospital", logo: AFH },
  { name: "Mecatech", logo: Mecatech },
  { name: "Al-Aleem Medical College", logo: Alaleem },
  { name: "Olympia PolyChem", logo: Olympia },
  { name: "Sapphire", logo: Sapphire },
  { name: "Diamond Paints", logo: Diamond },
  { name: "Atlas Power", logo: Atlas },
  { name: "JK Sugars", logo: JKSugars },
  { name: "JK Dairy Farm", logo: JKDairyFarm },
  { name: "Ihsan", logo: Ihsan },
  { name: "Haier", logo: Haier },
  { name: "Hamdard", logo: Hamdard },
  { name: "Marhaba", logo: Marhaba },
  { name: "Maheen Textile Mills", logo: Maheen },
  { name: "Malmo", logo: Malmo },
  { name: "Sapphire Dairies", logo: SapphireDairies },
  { name: "Khalas Sale Kurma", logo: KhalasSaleKurma },
  { name: "Sabroso", logo: Sabroso },
  { name: "Glamour Garments", logo: GlamourGarments },
  { name: "Divine Olive Oil", logo: Divine }
];

export default ClientsData;
